const crossBar = () => {
    const crossBarUl = document.querySelector('ul.zzFamilyLst');
    if (!crossBarUl) {
        $('.main-frame').hide();
    }
};
export default crossBar;
